import request from '../api';

// 获取媒体分类
export function getMultimediaCategoriesType() {
  return request.post('/app/multimediaCategories/getType');
}
